module.exports = __webpack_public_path__ + "media/images/plans/photo_studio/point-title-1-9c6aaae1ea6eb31e2121aa03d3a26dcb.png";